﻿import { Application } from '../application';
import { Component, Attribute, Input, Output, OutputArgs, IComponent, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { CaseFileData } from "../../models/file";
import { User } from "../../models/user";
import { ActionLinkAction } from "../../interfaces/iFqs";
import { AuthorizationService } from "../../services/authorizationService";

export type ChatType = "internal" | "external" | "all";
@Component({
    module: FIQAssist,
    selector: 'conversationentry',
    template: `<table class="conversationentry"><tr>
                <td class="attachmentbutton">
                    <fileuploadbutton read-only="$ctrl.readOnly || $ctrl.authorizationService.currentRoleIn(['FQS'])" onfileadded="$ctrl.onNewAttachment(file)"></fileuploadbutton></span>
                </td>
                <td class="fixture top">
                    <fqtextarea candelete="true" on-layout-reset="$ctrl.resetDynamicHTMLLayout()" on-layout-ajust="$ctrl.ajustDynamicHTMLLayout(height)" read-only="$ctrl.readOnly" value="$ctrl.corsText" onvaluechanged="$ctrl.onValueChanged(value)" tooltip-placement="'bottom'"></fqtextarea>
                </td>
                <td class="feedbackbutton" ng-show="$ctrl.feedbackStatusLinks.length > 0">
                    <pushbutton isdisabled="$ctrl.readOnly || $ctrl.isdisabled || $ctrl.isFeedbackDisabled" class="buttonfeedback" buttontext="{{$ctrl.feedbackButtonText |translate}}" onclicked="$ctrl.onSendFeedback()"></pushbutton>
                </td>
                <td class="sendbutton">
                    <div class="button-container" click-outside="$ctrl.buttonOpen = false">
                        <pushbutton indicator-color="{{$ctrl.authorizationService.currentRoleIn(['FQS']) ? '#B5DA91' : '' }}" isdisabled="$ctrl.readOnly || $ctrl.isdisabled" buttontext="{{ ( $ctrl.showExternal ? 'SEND' : 'SEND_INTERNAL') | translate}}" onclicked="$ctrl.onSend()"></pushbutton>
                        <div class="button-option ng-class:{disabled:$ctrl.readOnly || $ctrl.isdisabled}" ng-if="$ctrl.chatType == 'all'">
                            <div class="button-option-text" ng-if="$ctrl.buttonOpen" ng-click="$ctrl.onInternal()">
                                <span class="button-label"><div class="button-icon"></div>{{ 'SEND_INTERNAL' | translate}}<span>
                            </div>
                            <div class="button-option-handle" ng-click="$ctrl.buttonOpen = !($ctrl.readOnly || $ctrl.isdisabled) && !$ctrl.buttonOpen">
                                <span class="icon-driehoek1 ng-class:{closed:!$ctrl.buttonOpen,open:$ctrl.buttonOpen}">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                    <span class="path3"></span>
                                    <span class="path4"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr></table>`,
    require: {
        application: "^application"
    }
})
export class ConversationEntry {
    private buttonOpen = false;

    public application: Application;
    public isFiqasEmployee: boolean;

    public isFeedbackDisabled: boolean;
    private _feedbackStatusLinks: FeedbackStatusLink[];
    @Input() set feedbackStatusLinks(links: FeedbackStatusLink[]) {
        links = links || [];
        this._feedbackStatusLinks = (this.authorizationService.currentRole === "FQS")
                ? []
                : links.filter(l => ['provided', 'requested'].indexOf(l.id) > -1);
        this.isFeedbackDisabled = (
                (this.authorizationService.currentRole === "FQS")
                || !((this.authorizationService.currentRole === "CUST")
                    ? this._feedbackStatusLinks.some(l => l.id == 'provided')
                    : this._feedbackStatusLinks.some(l => l.id == 'requested'))
            );
        this.feedbackButtonText = (this.authorizationService.currentRole === "FQS")
                ? ""
                : (this.authorizationService.currentRole === "SD") ? 'REQUEST_FEEDBACK' : 'SEND_FEEDBACK'
            ;
    }
    get feedbackStatusLinks(): FeedbackStatusLink[] {
        return this._feedbackStatusLinks || [];
    }
    private feedbackButtonText: string;

    private _chatType: ChatType;
    @Input() public get chatType() {
        return this._chatType;
    }
    public set chatType(value: ChatType) {
        this._chatType = value;
        if (this._chatType == "external")
            this.buttonOpen = false;
    }

    private get showInternal(){
        return this._chatType != "external";
    }

    private get showExternal(){
        return this._chatType != "internal";
    }

    @Input() public readOnly: boolean;
    @Output() public onnewentry: OutputArgs<{ entry: string, internal: boolean }>;
    @Output() public onfeedback: OutputArgs<{ feedback: string, status: FeedbackStatusLink }>;
    @Output() public onnewattachment: OutputArgs<{ attachment: CaseFileData }>;
    @Output() public onvaluechanged: OutputArgs<{ value: string }>;
    @Output() public onLayoutAjust: OutputArgs<{ height: number }>;
    @Output() public onLayoutReset: OutputArgs<{}>;
    public ajustDynamicHTMLLayout(height: number) {
        if (this.onLayoutAjust) this.onLayoutAjust({ height: height });
    }
    public resetDynamicHTMLLayout() {
        if (this.onLayoutReset) this.onLayoutReset({});
    }


    constructor(
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$uibModal') private $modal: angular.ui.bootstrap.IModalService,
        @Inject() private authorizationService: AuthorizationService
    ) {
    }

    $onInit() {
    }

    private corsText: string;
    private isdisabled: boolean = true;

    public onValueChanged(val: string) {
        this.corsText = val;
        this.isdisabled = !(val && val.length > 0);
        this.onvaluechanged({ value: val });
    }

    public onSendFeedback() {
        if (this.authorizationService.currentRole === "FQS")
            return;

        this.onfeedback({
            feedback: this.corsText,
            status: (this.authorizationService.currentRole === "CUST") ? this.feedbackStatusLinks.filter(x => x.id == "provided")[0] : this.feedbackStatusLinks.filter(x => x.id == "requested")[0]
        });
        this.corsText = '';
    }

    public async onSend() {
        if(!this.showExternal){
            this.onInternal();
            return;
        }
        if(this.authorizationService.currentRole == "CUST" && this._feedbackStatusLinks.some(l => l.id == 'provided')){
            let options: ng.ui.bootstrap.IModalSettings = {
                animation: false,
                templateUrl: '/views/send.feedback.dialog.html',
                controller: SendFeedbackDialogComponent,
                controllerAs: '$ctrl',
                backdrop:'static'
            };
            try {
                let m = this.$modal.open(options);
                let x = await m.result
                if(x == "feedback"){
                    this.onSendFeedback();
                    return;
                }
            } catch (_) {
                var e = _;
            }
        }
        this.onnewentry({ entry: this.corsText, internal: false });
        this.corsText = '';
    }

    public onInternal() {
        this.onnewentry({ entry: this.corsText, internal: true });
        this.buttonOpen = false;
        this.corsText = '';
    }

    public onNewAttachment(fileData: CaseFileData) {
        this.onnewattachment({ attachment: fileData });
    }
}

export class SendFeedbackDialogComponent {
    static controllerId = 'SendFeedbackDialogComponent';

    constructor(
        @Inject('$uibModalInstance') private $modalInstance: angular.ui.bootstrap.IModalServiceInstance
    ) {

    }
    public AsFeedback() {
        this.$modalInstance.close('feedback');
    }

    public AsCorrespondence() {
        this.$modalInstance.close('correspondence');
    }
}

export interface FeedbackStatusLink {
    id: string;
    name: string;
    act: ActionLinkAction<any, any, void>;
}
